import pushModel from "@/mixin/store/api/pushModel";
import axios from "@/plugins/axios";

export default {
    actions: {
        fetchTopProducts(context, data) {
            if (context.state.topProducts.isNeedFetch) {
                return pushModel(context, 'sale_products/period_top', data, 'updateTopProducts')
            }
        },
        fetchTopProductsLastPeriod(context) {
            if (context.state.topProducts.isNeedFetch) {
                return axios.get('sale_product_daily_ratings/last_period')
                    .then((response) => {

                        let data = {
                            models: response.data,
                        }

                        context.commit('updateTopProducts', data)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        searchTodaySaleProducts(context, searchItem) {
            let url = "sale_products/today-sale?"

            if (searchItem.before) {
                url = url + 'createdAt[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&createdAt[after]=' + searchItem.after
            }

            if (searchItem.productId) {

                url = url + '&product=' + searchItem.productId
            }

            return axios.get(url)
                .then((response) => {
                    context.commit('updateTodaySaleProducts', response.data)
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    mutations: {
        updateTopProducts(state, data) {
            if (data.models) {
                state.topProducts.models = data.models
            } else {
                state.topProducts.models = data
            }

            state.topProducts.isNeedFetch = false
        },
        updateTodaySaleProducts(state, data) {
            state.todaySaleProducts = data
        }
    },
    state: {
        topProducts: {
            models: [],
            isNeedFetch: true
        },
        todaySaleProducts: []
    },
    getters: {
        getTopProducts(state) {
            return state.topProducts.models
        },
        getTodaySaleProducts(state) {
            return state.todaySaleProducts
        }
    },
}
